module.exports = __webpack_public_path__ + "static/media/bf21ee40d6ffb3fb524a0c16e2b81130.bf21ee40.mp4";